<div class="notification-panel" @slideInOut id="notificationPanel" >
    <div class="notification-header">
        <h3> {{ 'NOTIFICATIONS' | translate }} <span class="badge">{{notificationCount}}</span></h3>
        <div class="header-actions" *ngIf="notifications.length !== 0">
            <button mat-icon-button (click)="markAllAsRead()" matTooltip="Mark all as read">
                <mat-icon>done_all</mat-icon>
            </button>
            <!-- <button mat-icon-button (click)="clearNotifications()" matTooltip="Clear all">
                <mat-icon>delete</mat-icon>
            </button> -->
        </div>
    </div>

    <div class="spinner__loading" *ngIf="loader">  
        <mat-spinner></mat-spinner>
    </div>
    <div class="notification-scroll-container">
        <div class="notification-item" *ngFor="let notification of notifications | slice :0:3"
            [class.unread]="!notification.IsViewed">
            <!-- <mat-icon class="notification-icon">{{notification.icon}}</mat-icon> -->
            <div class="notification-content">
                <p class="fw-bold">{{notification?.NotificationTitle}}</p>
                <p>{{notification?.NotificationDescription}}</p>
                <small>{{getTimeAgo(notification.CreatedDate)}}</small>
            </div>
            <div class="notification-actions">
                <button mat-icon-button (click)="markAsRead(notification.NotificationId)" *ngIf="!notification.IsViewed">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>

        <div class="empty-state" *ngIf="notifications.length === 0 && !loader">
            <mat-icon>notifications_off</mat-icon>
            <p>{{ 'NO_NOTIFICATION' | translate }}</p>
        </div>
    </div>

    <div class="notification-footer">
        <button mat-button color="primary" (click)="viewAll()">{{ 'VIEW_ALL' | translate }}</button>
    </div>
</div>